
export const INPUT_DEBOUNCE_DELAY = 3000;
export const DELETE_ARTICLE_CONFIRMATION_MSG = 'Are you sure you wish to delete this article?';
export const PAGE_NAME = 'a-z-of-motorcycles';
export const UPLOADER_ADDRESS = '/ckfinder.html?type=Images&CKEditor=editor4&CKEditorFuncNum=115&langCode=en';
export const MODAL_BODY_ID = 'image-upload-modal__body';
export const MODAL_ID = 'image-upload-modal';
export const JQUERY_IDENTIFIER = '$';

export interface PageSettings {
  pageName: string,
}

export interface CKEditorEditor {
  getData: (arg?: any)=>string
}

export interface updateArticleHandler<T=string> {
  (arg0: T, arg1?: string): void,
}

export interface CKEditorEvent {
  editor: CKEditorEditor
}
